
import Customer from '@/Models/Customer'

const state = () => ({
  /**
   * This variable contains all the searchable customers.
   * @type Array
   */
  items: [],

  /**
   * The search string.
   * @type String
   */
  needle: '',
})

const getters = {
  filtered: state => state.needle.length === 0
    ? state.items
    : state.items.filter(o => o.contains(state.needle)),
}

const mutations = {
  items (state, customers) {
    state.items = customers ?? []
  },
  needle (state, v) {
    state.needle = v
  },
}

const actions = {
  init ({ commit, rootState }) {
    commit('needle', '')
    commit('items', rootState.rummage.data['Customer']
      ?.filter(o => !! o.active)
      .sortByString('name')
      .map(customer => new Customer(customer))
    )
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
